<template>
  <div id="stripe-card">
    <el-alert
      v-if="error"
      type="error"
      :title="error"
      :closable="false"
    />

    <el-card :shadow="shadow">
      <h5 slot="header">Card Details :</h5>
      <div ref="card"></div>
    </el-card>

    <el-card v-if="showDetails" :shadow="shadow">
      <h5 slot="header">
        <el-button size="mini" @click="edit = true">Edit informations</el-button>
        Billing Address :
      </h5>

      <Details
        v-if="edit || details.email || details.name || details.address"
        :address.sync="details.address"
        :name.sync="details.name"
        :email.sync="details.email"
        size="mini"
        :show-business="showBusiness"
        :show-email="showEmail"
      />

      <label v-else>You can provide the billing address associated with the credit card.</label>
    </el-card>

    <el-button
      v-if="showAdd"
      type="primary"
      :loading="loading"
      @click.prevent="add"
    >
      {{ saveLabel }}
    </el-button>

    <el-button
      v-if="showCancel"
      type="default"
      @click="$emit('cancel')"
    >
      Cancel
    </el-button>

    <p>
      <small>By saving a payment method, you agree to Runstack's
        <a href="https://runstack.io/terms" target="_blank">Terms of Services</a>.
      </small>
    </p>

    <p>
      <img src="../../assets/powered-stripe-alt.svg" class="powered" />
      <img src="../../assets/card-visa.svg"  class="card "/>
      <img src="../../assets/card-mastercard.svg"  class="card "/>
      <img src="../../assets/card-amex.svg"  class="card "/>
    </p>
  </div>
</template>

<script>
import Vue from 'vue'
import Details from './Details'
// eslint-disable-next-line no-undef
const stripe = Stripe(process.env.VUE_APP_STRIPE_KEY)
const elements = stripe.elements()
let stripeCard

export default {
  props: {
    shadow: {
      type: String,
      default: 'always'
    },
    showAdd: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    showDetails: {
      type: Boolean,
      default: true
    },
    showBusiness: {
      type: Boolean,
      default: true
    },
    showEmail: {
      type: Boolean,
      default: true
    },
    saveLabel: {
      type: String,
      default: 'Save Card'
    },
    forceCreate: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Details
  },
  data () {
    return {
      error: null,
      loading: false,
      edit: false,
      details: {
        name: undefined,
        email: undefined,
        address: undefined,
        forceCreate: this.forceCreate
      }
    }
  },
  mounted () {
    stripeCard = elements.getElement('card') || elements.create('card', {
      hidePostalCode: true,
      style: {
        base: {
          color: '#000'
        }
      }
    })
    stripeCard.mount(this.$refs.card)
  },
  beforeDestroy () {
    if (stripeCard) {
      stripeCard.clear()
      this.edit = false
    }
  },
  methods: {
    add () {
      this.loading = true
      this.error = null

      return this.$store.dispatch('createPaymentMethod', this.details)
        .then((intent) => this.confirm(intent))
        .then((result) => this.$store.dispatch('savePaymentMethod', result.setupIntent))
        .then(() => this.$emit('save'))
        .catch(() => {
          this.error = 'An error has occurred with your card. Try again.'
          this.loading = false
          this.$forceUpdate()
        })
    },
    confirm (intent) {
      return stripe.confirmCardSetup(intent.secret, {
        payment_method: {
          type: 'card',
          card: stripeCard
        }
      }).then((result) => {
        if (result.error) {
          this.error = 'An error has occurred with your card'
        }

        if (result.error) {
          this.loading = false
          this.$forceUpdate()
        }
        if (intent.roleId) {
          Vue.api.defaults.headers.common['x-runstack-role'] = intent.roleId
        }

        return result
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  label {
    color: $--color-text-gray;
    font-size: 13px
  }
  h5 {
    .el-button {
      float: right;
      position: relative;
      top: -6px;
    }
  }
</style>

<style lang="scss">
  @import "../../theme";

  #stripe-card {
    .el-alert {
      margin-bottom: 20px;
    }
    .el-card {
      max-width: 500px;
      margin-bottom: 20px;
    }
    .el-card__header {
      padding-top: 0;
      padding-bottom: 0;
    }
    .powered {
      float: right;
      height: 30px;
      max-height: 30px;
    }
    .card {
      height: 30px
    }
    a {
      color: $--color-text-primary;
    }
  }
</style>
